import { Box, Grid, styled } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import Logo from 'assets/logo.png'
import GreenFullscreen from 'router/layouts/InstallLayout'
import NewVersion from './NewVersion'
import LoadingDot from './LoadingDot'

interface IInstallingSplashScreen {
    isNewVersion?: boolean
}

const ImageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
    },
    [theme.breakpoints.up('md')]: {
        justifyContent: 'flex-end',
    },
}))

const ImageContainerNoNewInstalling = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
}))

function InstallingSplashScreen({
    isNewVersion = false,
}: IInstallingSplashScreen) {
    const { isMobile } = useScreenSize()
    return (
        <GreenFullscreen
            direction={'column'}
            container
            alignItems={'center'}
            alignContent={'center'}
            justifyContent={'center'}
        >
            <Grid>
                {isNewVersion ? (
                    <ImageContainer>
                        <img
                            style={{
                                width: isMobile ? 340 : 412,
                            }}
                            src={Logo}
                            alt="logo"
                        />
                    </ImageContainer>
                ) : (
                    <ImageContainerNoNewInstalling>
                        <img
                            style={{
                                width: isMobile ? 340 : 412,
                            }}
                            src={Logo}
                            alt="logo"
                        />
                    </ImageContainerNoNewInstalling>
                )}
            </Grid>
            {isNewVersion ? (
                <Grid>
                    <NewVersion />
                </Grid>
            ) : (
                <Grid>
                    <LoadingDot />
                </Grid>
            )}
        </GreenFullscreen>
    )
}
export default InstallingSplashScreen
